import { atom } from "recoil";

export const defaultPrizeTypeOrder = ["item", "chest", "freespins", "tickets", "money"];

export const prizeSettingsModalStore = atom({
	key: "prizeSettingsModalStore",
	default: {
		show: false,
		loaded: true,
		error: "",
		order: defaultPrizeTypeOrder,
	},
});
